<div class="filter-field">
  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" [value]="value" placeholder="Buscar"
      [disabled]="disabled" />
  </mat-form-field>

  @if (showSomenteAtivos) {
  <mat-slide-toggle color="primary" [checked]="somenteAtivos" (change)="applySomenteAtivos($event.checked)">
    {{ somenteAtivosLabel }}
  </mat-slide-toggle>
  }
</div>